import React from "react";
import { Card, CardContent, Typography, Avatar } from "@material-ui/core";
import image from "../../../helper/image";
import "./BookingLineupCards.css";

const ActAdminCard = ({
    actName,
    adminName,
    adminProfile,
    performanceFee,
    superFee,
    invoiceAmount,
    currencySymbol
}) => {
    return (
        <div className="lineup-admin-card">
            <Card elevation={1}>
                <div className="lineup-admin-card-header">
                    <div className="lineup-admin-card-badge">Act Admin</div>
                </div>
                
                <CardContent className="lineup-admin-card-content">
                    <div className="lineup-admin-card-profile">
                        {adminProfile && (
                            <Avatar 
                                className="lineup-admin-card-avatar" 
                                src={image.getProfileImage(adminProfile)} 
                                alt={adminName}
                            />
                        )}
                        <div className="lineup-admin-card-info">
                            <Typography variant="subtitle1" className="lineup-admin-card-name">
                                {adminName}
                            </Typography>
                            <Typography variant="caption" className="lineup-admin-card-act">
                                {actName}
                            </Typography>
                        </div>
                    </div>

                    <div className="lineup-admin-card-details">
                        <div className="lineup-admin-card-row">
                            <span className="lineup-admin-card-label">Performance Fee</span>
                            <span className="lineup-admin-card-value">
                                {currencySymbol} {performanceFee}
                            </span>
                        </div>
                        <div className="lineup-admin-card-row">
                            <span className="lineup-admin-card-label">Super Fee</span>
                            <span className="lineup-admin-card-value">
                                {currencySymbol} {superFee}
                            </span>
                        </div>
                        <div className="lineup-admin-card-row lineup-admin-card-total">
                            <span className="lineup-admin-card-label">Invoice Amount</span>
                            <span className="lineup-admin-card-value">
                                {currencySymbol} {invoiceAmount}
                            </span>
                        </div>
                    </div>
                </CardContent>
            </Card>
        </div>
    );
};

export default ActAdminCard;
